export const normalizeUrl = (url?: string | null): string | null => {
  const trimmedUrl = url?.trim() || '';
  if (!trimmedUrl) return null;

  const cleanedUrl = /^https?:\/\//i.test(trimmedUrl) ? trimmedUrl : trimmedUrl.replace(/^\/+/, '');
  const hasProtocol = /^[a-z][a-z\d+.-]*:/i.test(cleanedUrl) && !/^[^/:?#]+:\d+(?:[/?#]|$)/.test(cleanedUrl);
  const normalizedUrl = hasProtocol ? cleanedUrl : `https://${cleanedUrl}`;

  try {
    const parsedUrl = new URL(normalizedUrl);
    const hostnameParts = parsedUrl.hostname.split('.');
    const topLevelDomain = hostnameParts[hostnameParts.length - 1];
    const isDomain =
      hostnameParts.length > 1 &&
      /^(?:[a-z]{2,}|xn--[a-z\d-]+)$/i.test(topLevelDomain) &&
      hostnameParts.every((part) => /^[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?$/i.test(part));
    const isIpAddress = /^(?:\d{1,3}\.){3}\d{1,3}$/.test(parsedUrl.hostname) || /^\[.+\]$/.test(parsedUrl.hostname);

    if (
      (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') ||
      (!isDomain && !isIpAddress) ||
      parsedUrl.port === '0' ||
      /\s/.test(trimmedUrl)
    ) {
      return null;
    }
    return parsedUrl.href;
  } catch {
    return null;
  }
};
